import React from "react";
import PaymentInfo from "../components/PaymentInfo";
import ContributeForm from "../components/ContributeForm";

function Contribute() {
  return (
    <div className="py-10 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl sm:text-4xl font-bold text-sritaru-800 text-center mb-8">
          Contribute Trees &#127795;
        </h1>

        {/* Payment Info */}
        <div className="mb-10">
          <h2 className="text-xl font-semibold text-sritaru-700 text-center mb-6">
            Step 1: Make Payment
          </h2>
          <PaymentInfo />
        </div>

        {/* Form */}
        <div>
          <h2 className="text-xl font-semibold text-sritaru-700 text-center mb-6">
            Step 2: Register Your Contribution
          </h2>
          <ContributeForm />
        </div>
      </div>
    </div>
  );
}

export default Contribute;
